import ProfileSection from '../ProfileSection';
import type { PlayerProfileAvailabilitySlot } from 'screens/PlayerProfile/types';

interface Props {
  availability: PlayerProfileAvailabilitySlot[];
  isViewerProfile: boolean;
  onEdit?: () => void;
}

export default function ProfilePreferredTime({ availability, isViewerProfile, onEdit }: Props) {
  return (
    <ProfileSection
      title="Preferred time to play"
      isViewerProfile={isViewerProfile}
      onEdit={onEdit}
      isEmpty={!availability.length}
      emptyLabel="Add info"
      titleSize="sm"
    >
      <div className="flex flex-wrap items-center gap-ds-md">
        {availability.map(({ key, dayLabel, timeLabel }) => (
          <span
            key={key}
            className="typography-product-button-label-small flex items-center gap-ds-xs rounded-full bg-color-bg-lightmode-secondary px-ds-md py-1.5 text-color-text-lightmode-primary dark:bg-color-bg-darkmode-secondary dark:text-color-text-darkmode-primary"
          >
            <span>{dayLabel}</span>
            <span className="text-color-text-brand">•</span>
            <span>{timeLabel}</span>
          </span>
        ))}
      </div>
    </ProfileSection>
  );
}
